import { IComponentOptions } from "angular";
import { ProcessNotesComponentController } from "./controller";

export const vsComponentName = "processNotesModalComponent";

export const ProcessNotesModalComponentOptions: IComponentOptions = {
  controller: ProcessNotesComponentController,
  controllerAs: "processNotesModalController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    process: "<",
    state: "<",
    processInformation: "<",
  },
};
